import { render } from "./testPaper.vue?vue&type=template&id=2f49181c&scoped=true&ts=true"
import script from "./testPaper.vue?vue&type=script&lang=ts"
export * from "./testPaper.vue?vue&type=script&lang=ts"

import "./testPaper.vue?vue&type=style&index=0&id=2f49181c&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f49181c"]])

export default __exports__